import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const DotsVerticalIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 3 15">
    <circle cx={1.5} cy={1.5} r={1.5} fill={props.stroke} stroke="none" />
    <circle cx={1.5} cy={7.5} r={1.5} fill={props.stroke} stroke="none" />
    <circle cx={1.5} cy={13.5} r={1.5} fill={props.stroke} stroke="none" />
  </SvgIcon>
);
